module.exports = __webpack_public_path__ + "img/batch_wash_and_fill.png";